export default __webpack_public_path__ + "static/media/common_velvetgrass.2653d06d.jpeg";